import { useProfileStore } from 'stores/profile-store';
import { TNormalizedPeopleUnit, TNormalizedUnit } from 'types';
import { constants } from 'boot/constants';

export function memberOfUnit(unitToTest: TNormalizedUnit): boolean {
  const profileStore = useProfileStore();
  const units = profileStore.getUnits();
  return units.some(
    (unit: TNormalizedPeopleUnit) =>
      unit.id === unitToTest.id &&
      unit.membership_type_id !== undefined &&
      [constants.SUBSCRIBING, constants.HONORARY].includes(
        unit.membership_type_id
      )
  );
}
